import React from "react";
import {
    Form,
    Row,
    Col,
    Select,
    Icon,
    Layout,
    message,
    Slider,
    Button,
} from "antd";
import img from '../../../assets/img/At the office-pana 1.png';
import MiCompAPI from "../../../util/api";
import TableWrapper from "../../elements/TableWrapper";
const { Content } = Layout;
const { Option } = Select;
class MI extends React.Component {
    constructor(props) {
        super(props);
        this.columns = [{
            title: 'Name',
            dataIndex: 'name',

        },
        {
            title: 'Carrier',
            dataIndex: 'carrier',
            render: (text, record) => record.other_ids.map((x, index) => {
                return (
                    x.issuer +
                    (record.other_ids.length - 1 !==
                        index
                        ? ", "
                        : "")
                );
            })
        },
        {
            title: 'Address',
            dataIndex: 'address',
            render: (text, record) => record.addr_practice.full
        },
        {
            title: 'City',
            dataIndex: 'city',

        },
        {
            title: 'State',
            dataIndex: 'state',

        },
        {
            title: 'Mobile Number',
            dataIndex: 'mobile',
            render: (text, record) => record.addr_practice.phone
        },
        {
            title: 'Distance(Miles)',
            dataIndex: 'distance',
            render: (text, record) => text && text.toFixed(2) + ' miles',
            sorter: (a, b) => a.distance - b.distance,
            sortDirections: ["descend", "ascend"]


        },
        ];
        this.columns_search = [{
            title: 'Provider ',
            dataIndex: 'provider',
            render: (text, record) => text === "P" ? "Physician" : "Hospital"

        },
        {
            title: 'Speciality / Type',
            dataIndex: 'speciality',
        },
        {
            title: 'Min Distance',
            dataIndex: 'minmiles',
        },
        {
            title: 'Max Distance',
            dataIndex: 'maxmiles',
        },
        ];

        this.state = {
            Providers: [],
            inputValue: [0, 100],
            datatbl: [],
            isLoading: false,
            providerhistory: [],
        };
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    componentDidMount = () => {
        this.GetSearchHistory(this.props.location.state ? this.props.location.state : 0);
    }
    componentWillMount = () => {
        const { setFieldsValue } = this.props.form;

        setFieldsValue({
            miles: this.state.inputValue,

        });
    }
    GetProvider = (type, ischange) => {
        this.api.invoke(
            "GetProvider/" + type,
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        const { setFieldsValue } = this.props.form;
                        setTimeout(() => {
                            if (ischange)
                                setFieldsValue({
                                    taxonomy: undefined
                                });
                        }, 100);
                        this.setState({
                            Providers: data.data,

                        });
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            },
        );
    };
    GetSearchHistory(brokerId) {
        this.api.invoke(
            "GetSearchHistory/" + brokerId,
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200 && data.data) {
                        this.providerhistory = [data.data]
                        const { setFieldsValue } = this.props.form;
                        this.GetProvider(data.data.provider, false);
                        setTimeout(() => {
                            this.setState({
                                inputValue: [data.data.minmiles, data.data.maxmiles]
                            })
                            setFieldsValue({
                                miles: [data.data.minmiles, data.data.maxmiles],
                                type: data.data.provider,
                                taxonomy: data.data.specialityId
                            });
                            this.ProviderSearch(data.data.provider, data.data.specialityId, [data.data.minmiles, data.data.maxmiles]);

                        }, 200);

                    }
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        );
    }
    ProviderSearch = (type, taxonomy, miles) => {

        this.setState({
            isLoading: true
        })
        if (!miles) {
            miles = this.state.inputValue
        }
        let userId = this.props.location.state ? this.props.location.state : 0;
        this.api.invoke(
            "ProviderSearch/" + userId + "/" + type + "/" + taxonomy + "/" + miles[0] + "/" + miles[1],
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({
                            datatbl: data.data,
                            isLoading: false

                        });
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            },
        );
    };
    onChange = (e) => {
        this.GetProvider(e, true);
    }
    onChangerange = value => {
        this.setState({
            inputValue: value,
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.ProviderSearch(values.type, values.taxonomy, values.miles);
            }
        });
    }

    render() {
        const { inputValue } = this.state;
        const { getFieldDecorator } = this.props.form;
        return (
            <Content>
                <div className="mi_main_div" style={{ paddingTop: "45px" }}>
                    <div className="mi_box_sd">
                        <Row span={24}>
                            <Col span={18}>
                                <h4 className="mi_box_h4">Provider Search</h4>
                            </Col>
                            <Col span={6}>
                                <img alt="example" style={{ marginTop: '-80px' }} src={img} />
                            </Col>
                        </Row>
                    </div>
                    <div className="mi_main" style={{ marginTop: '-10px' }}>
                        <Row>
                            <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
                                <Row span={24}>
                                    <Col md={8} sm={24}>
                                        <Form.Item>
                                            <fieldset className="mi_input_pop" style={{ marginRight: '2px' }}>
                                                <legend className="legend-font">Provider</legend>
                                                {getFieldDecorator('type', {
                                                    rules: [{ required: true, message: 'Please select Provider' },
                                                    ],
                                                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                                    onChange={this.onChange}
                                                    showSearch={true}
                                                    filterOption={(input, Option) =>
                                                        Option.props.children
                                                            .toLowerCase()
                                                            .indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    placeholder="Please Select Provider">

                                                    <option value="P" key="Physician" >Physician</option>
                                                    <option value="H" key="Hospital" >Hospital</option>

                                                </Select>
                                                )}
                                            </fieldset>
                                        </Form.Item>
                                    </Col>
                                    <Col md={8} sm={24}>
                                        <Form.Item>
                                            <fieldset className="mi_input_pop" style={{ marginRight: '2px' }}>
                                                <legend className="legend-font">Speciality / Type</legend>
                                                {getFieldDecorator('taxonomy', {
                                                    rules: [{ required: true, message: 'Please select Speciality' },
                                                    ],
                                                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                                    optionFilterProp="children"
                                                    showSearch={true}
                                                    filterOption={(input, Option) =>
                                                        Option.props.children
                                                            .toLowerCase()
                                                            .indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    placeholder="Please Select Speciality / Type">
                                                    {this.state.Providers ? this.state.Providers.map(x => <Option value={x.code} key={x.code}>{x.name}</Option>) : ""}
                                                </Select>
                                                )}
                                            </fieldset>
                                        </Form.Item>
                                    </Col>
                                    <Col md={1} sm={24} style={{ marginTop: '40px', marginLeft: '15px', marginRight: '-50px', fontWeight: '500' }}>[{inputValue[0]}]</Col>
                                    <Col md={6} sm={20} style={{ marginLeft: '20px' }}>
                                        <Form.Item>
                                            <fieldset className="mi_input_pop fieldset_border" style={{ marginRight: '2px' }}>
                                                <legend className="legend-font">Distance(Miles)</legend>
                                                {getFieldDecorator('miles')(
                                                    <Slider
                                                        range={true}
                                                        step={5}
                                                        tooltipPlacement="bottom"
                                                        defaultValue={inputValue}
                                                        onChange={this.onChangerange}
                                                        //  value={inputValue}
                                                        value={inputValue}

                                                    />
                                                )}
                                            </fieldset>
                                        </Form.Item>
                                    </Col>
                                    <Col md={1} sm={24} style={{ marginTop: '40px', marginLeft: '20px', marginRight: '-25px', fontWeight: '500' }}>[{inputValue[1]}]</Col>
                                </Row>
                                <Row>
                                    <Button className="submit-button" htmlType="submit" type="primary" style={{ marginLeft: '18px' }}>
                                        Search
                                    </Button>

                                </Row>
                            </Form>
                        </Row>
                    </div>
                    <div className="" style={{ marginLeft: "12px", marginRight: "12px" }}>
                        <TableWrapper rowKey="id" columns={this.columns} data={this.state.datatbl} loading={this.state.isLoading} title="All Providers" search={true} />
                    </div>
                    <div className="" style={{ marginLeft: "12px", marginRight: "12px" }}>
                        {/* <TableWrapper rowKey="id" columns={this.columns_search} data={this.providerhistory} title="Search History" search={true} /> */}
                    </div>
                </div>
            </Content>
        )
    }
}
const Providerssearch = Form.create()(MI);
export default Providerssearch;